export const normalize = (url, abs = true) => [
    abs && "/",
    url,
    "/",
].filter(Boolean).join("").replace(/\/{2,}/g, "/");